import { clearAllPhotos, clearAllMedia } from "./indexedDB";

type ResetOptions = {
  preserveLocalStorageKeys?: string[];
};

export const resetClientStorage = async (
  options: ResetOptions = {}
) => {
  const { preserveLocalStorageKeys = [] } = options;

  const preservedEntries = new Map<string, string>();
  try {
    preserveLocalStorageKeys.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        preservedEntries.set(key, value);
      }
    });

    localStorage.clear();

    preservedEntries.forEach((value, key) => {
      localStorage.setItem(key, value);
    });
  } catch (error) {
    console.error("Failed to reset localStorage", error);
  }

  try {
    sessionStorage.clear();
  } catch (error) {
    console.error("Failed to reset sessionStorage", error);
  }

  try {
    await clearAllPhotos();
  } catch (error) {
    console.error("Failed to clear photo store", error);
  }

  try {
    await clearAllMedia();
  } catch (error) {
    console.error("Failed to clear media store", error);
  }

  if (typeof caches !== "undefined") {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    } catch (error) {
      console.error("Failed to clear cache storage", error);
    }
  }
};
